module.exports = __webpack_public_path__ + "public/images/spanish-background-pattern.76ae9b11c3d0a52af4e5335ef1ef7479.svg";